import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Request, Http, XHRBackend, RequestOptions, RequestOptionsArgs, Response} from '@angular/http';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

@Injectable()
export class ExtendedHttpService extends Http {

    constructor(backend: XHRBackend, defaultOptions: RequestOptions) {
        super(backend, defaultOptions);
      }

      request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        const token = JSON.parse(localStorage.getItem('AcessoAdm'));
        const tokenExists = token ? token.TOKEN ? true : false : false;
         if (typeof url === 'string' && tokenExists) {
          if (!options) {
            options = { headers: new Headers() } as any;
          }
            options.headers.set('Access-Control-Allow-Methods', 'PUT, GET, POST, DELETE, url');
            options.headers.set('Access-Control-Allow-Origin', '*');
            options.headers.set('Authorization', 'Bearer ' + token.TOKEN );
        } else if (tokenExists) {
            (url as any).headers.set('Access-Control-Allow-Methods', 'PUT, GET, POST, DELETE, (url as any)');
            (url as any).headers.set('Access-Control-Allow-Origin', '*');
            (url as any).headers.set('Authorization', 'Bearer ' + token.TOKEN );
        }
        return super.request(url, options);
      }
}



// WEBPACK FOOTER //
// ./src/app/jwt-interceptor.ts